import Vuex from 'vuex';
import axios from 'axios';
import config from '../config';
export default () => {
    return new Vuex.Store({
        state: {
            menu: [],
            isLogin: false,
            userinfo: {},
            address: {
                first_name: '',
                last_name: '',
                country: '',
                company: '',
                address: '',
                apartment: '',
                city: '',
                state: '',
                zip_code: '',
                phone: '',
            },
            isPay: false,
            payMethod: [
                // {
                //     disabled: true,
                //     icon: require('@/assets/images/pay_method_01.jpg'),
                // },
                {
                    icon: require('@/assets/images/pay_method_03.jpg'),
                    type: 2,
                },
                {
                    icon: require('@/assets/images/pay_method_02.jpg'),
                    type: 1,
                },
            ],
            isJump: false,
        },
        mutations: {
            navMenuInit(state, payload) {
                state.menu = payload.map(item => {
                    item.isChecked = false;
                    return item;
                });
            },
        },
        actions: {
            // 导航
            getNav(context, payload){
                return new Promise((resolve, reject) => { 
                    axios.get(config.nav)
                        .then((result) => {
                        if (result.data.code == 100) {
                            context.commit('navMenuInit', result.data.data);
                            resolve();
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            // 首页
            getHome(context, payload){
                return new Promise((resolve, reject) => { 
                    axios.get(config.home)
                        .then((result) => {
                        if (result.data.code == 100) {
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            // 列表
            getProducts(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.products, {
                        params: payload
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            result.data.data.list = result.data.data.list.map(item => {
                                item.activeIndex = 0;
                                return item;
                            })
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            // 详情
            getDetail(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.detail, {
                        params: payload
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            result.data.data.recommend = result.data.data.recommend.map(item => {
                                item.activeIndex = 0;
                                return item;
                            })
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            // 购物车 - 添加
            addShopping(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.addShopping, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload,
                        }
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            resolve(result.data);
                        } else {
                            reject(result.data);
                        }
                    }).catch((err) => {
                        reject();
                        console.log(err);
                    });
                })
            },
            // 购物车 - 列表
            getShopping(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.shopping, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            // 购物车 - 加减
            changeCount(context, payload) {
                axios.get(config.changeCount, {
                    params: {
                        token: localStorage.getItem('token'),
                        ...payload
                    }
                })
                .then((result) => {
                    if (result.data.code == 100) {

                    } else {

                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            // 购物车 - 删除
            shoppingRemove(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.shoppingRemove, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            resolve();
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 联系我们
            contact(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.contact, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    })
                    .then((result) => {
                        if (result.data.code == 100) {
                            resolve();
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 注册
            register(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.register, {
                        params: {
                            ...payload
                        }
                    })
                    .then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 登录
            login(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.login, {
                        params: {
                            ...payload
                        }
                    })
                    .then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 获取用户信息
            getUserinfo(context, payload) {
                axios.get(config.userinfo, {
                    params: {
                        token: localStorage.getItem('token'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        context.state.isLogin = true;
                        context.state.userinfo = result.data.data.userinfo;
                        if (result.data.data.address) context.state.address = result.data.data.address;
                    } else {
                        localStorage.removeItem('token');
                    }
                }).catch((err) => {
                    console.log(err);
                    localStorage.removeItem('token');
                });
            },
            // 保存地址
            saveAddress(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.saveAddress, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            context.state.address = payload;
                            resolve();
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 提交订单
            saveOrder(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.saveOrder, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data.data.order_code);
                        } else {
                            reject(result.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 支付
            pay(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.pay, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data);
                        } else {
                            reject(result.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 订单列表
            getOrderList(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.orderList, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 取消订单
            orderCancel(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.orderCancel, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 修改密码
            editPassword(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.editPassword, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 修改密码
            verifyCoupon(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.verifyCoupon, {
                        params: {
                            token: localStorage.getItem('token'),
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 找回密码-发送邮件
            sendVerifyEmail(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.sendVerifyEmail, {
                        params: {
                            ...payload,
                            type: 1
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve();
                        } else {
                            reject(result.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 找回密码-修改密码
            resetPassword(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.resetPassword, {
                        params: {
                            ...payload,
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve();
                        } else {
                            reject(result.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 上传图片
            upImages(content, payload) {
                return new Promise((resolve, reject) => { 
                    axios.post(config.upImage, payload, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data);
                        } else {
                            reject();
                        }
                    }).catch((err) => {
                        reject();
                    });
                });
            },
            // 获取聊天消息
            getMessage(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.getMessage, {
                        params: {
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        if (result.data.code == 100) { 
                            resolve(result.data.data);
                        } else {
                            reject();
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
        }
    })
}